import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { WEB_SOCKET_MODULE } from '../../configs/moduleNames';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

export const WS_CONNECTION = '_WS_CONNECTION';
export const WS_DISCONNECTION = '_WS_DISCONNECTION';
export const ON_MESSAGE = '_ON_MESSAGE';

export const wsConnection = createDeferredAction(WEB_SOCKET_MODULE + WS_CONNECTION);
export const wsDisconnection = createDeferredAction(WEB_SOCKET_MODULE + WS_DISCONNECTION);
export const wsConnectionSuccessful = createAction(WEB_SOCKET_MODULE + WS_CONNECTION + SUCCESSFUL);
export const wsConnectionFailed = createAction(WEB_SOCKET_MODULE + WS_CONNECTION + FAILED);
export const wsConnectionOnMessage = createAction(WEB_SOCKET_MODULE + WS_CONNECTION + ON_MESSAGE);
